var map = {
	"./CUP1.svg": 43001,
	"./CUP10.svg": 15020,
	"./CUP11.svg": 57824,
	"./CUP12.svg": 60692,
	"./CUP2.svg": 39138,
	"./CUP3.svg": 55060,
	"./CUP4.svg": 52845,
	"./CUP5.svg": 63561,
	"./CUP6.svg": 42997,
	"./CUP7.svg": 7720,
	"./CUP8.svg": 70679,
	"./CUP9.svg": 63262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57587;